import {
  CREATE_QUERIES,
  DELETE_QUERIES,
  DETAILS_QUERIES,
  LIKE_DISLIKE_QUERIES,
  LIKE_DISLIKE_REPLAY_QUERIES,
  LIST_QUERIES,
} from "../api";
import axiosInstance from "../axiosInstance";

export const createqueries = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(CREATE_QUERIES, props)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err.response?.data);
      });
  } catch (error) {}
};

export const Deletequeries = (id) => (onResponse) => {
  try {
    axiosInstance
      .delete(DELETE_QUERIES, { data: { id: id } })
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err.response?.data);
      });
  } catch (error) {}
};

export const Detailqueries = (props) => (onResponse) => {
  try {
    axiosInstance
      .get(DETAILS_QUERIES, props?.values)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err.response?.data);
      });
  } catch (error) {}
};

export const Listqueries = (props) => (onResponse) => {
  try {
    let BASE_URL = LIST_QUERIES + "?";
    if (props.page) {
      BASE_URL += "page=" + props.page + "&";
    }
    if (props.limit) {
      BASE_URL += "limit=" + props.limit + "&";
    }
    if (props.search) {
      BASE_URL += "search=" + props.search + "&";
    }
    if (props.sort_by) {
      BASE_URL += "sort_by=" + props.sort_by + "&";
    }
    if (props.object_id) {
      BASE_URL += "object_id=" + props.object_id + "&";
    }
    if (props.order) {
      BASE_URL += "order=" + props.order + "&";
    }

    axiosInstance
      .get(BASE_URL)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err.response?.data);
      });
  } catch (error) {}
};

export const Like_dislike_queries = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(LIKE_DISLIKE_QUERIES, props)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err.response?.data);
      });
  } catch (error) {}
};

export const Like_dislike_replay_queries = (props) => (onResponse) => {
  try {
    axiosInstance
      .post(LIKE_DISLIKE_REPLAY_QUERIES, props?.values)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err);
        onResponse(err.response?.data);
      });
  } catch (error) {}
};
